import React, { useMemo } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@vaiu/ui/card';
import { i18n } from '@/utils/i18n';
import type { MerchantProfile } from '@/types/api/merchant';

function catalogRows(merchant: MerchantProfile) {
  const fromProducts = merchant.catalog?.products || [];
  const fromSections = (merchant.catalog?.sections || []).flatMap((section) =>
    (section.products || []).map((product) => ({
      ...product,
      category: product.category || section.name,
    }))
  );
  return fromProducts.length > 0 ? fromProducts : fromSections;
}

const MerchantStorefrontCatalog: React.FC<{ merchant: MerchantProfile }> = ({ merchant }) => {
  const rows = useMemo(() => catalogRows(merchant), [merchant]);
  if (rows.length === 0) return null;

  return (
    <Card className="mb-8">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg">{i18n.__('merchantPublicProfile.menuTitle')}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {rows.map((item, index) => (
          <div key={`${item.name}-${index}`} className="flex items-start justify-between gap-4 border-b pb-3 last:border-0">
            <div>
              <p className="font-medium">{item.name}</p>
              {item.description ? (
                <p className="text-sm text-muted-foreground">{item.description}</p>
              ) : null}
              {item.category ? (
                <p className="text-xs text-muted-foreground mt-1">{item.category}</p>
              ) : null}
            </div>
            {item.price != null ? (
              <p className="font-semibold whitespace-nowrap">
                {item.currency ? `${item.currency} ` : ''}
                {item.price}
              </p>
            ) : null}
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default MerchantStorefrontCatalog;
